<div class="flex flex-col items-center px-4">
  <div class="w-full max-w-2xl mt-6 lg:w-screen">
    <h3 class="mb-6 text-xl font-bold">Status płatności</h3>
    <div class="flex justify-center text-red-600">
      <img class="error-icon" src="assets/img/cancelled-paid.svg" alt="Płatność wykonana innym kanałem" />
    </div>
    <div class="mt-6 mb-4 text-2xl text-center text-gray-900">
      Płatność została już wykonana
    </div>

    <div class="mb-8 text-sm text-center text-gray-700">
      Wybrana płatność została już wykonana innym kanałem (np. tradycyjnym przelewem lub gotówką u dostawcy usług) i nie
      może zostać wykonana ponownie.
      <br /><br />
      Jeśli masz jakieś pytania do tej płatności,
      <a
        (click)="openChat()"
        class="text-gray-700 underline transition-colors duration-150 cursor-pointer hover:text-gray-500"
        >napisz do nas</a
      >.
    </div>

    <app-value-proposition [highlight]="true"></app-value-proposition>
  </div>
</div>
